var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M612,58.8c-22.5,10-46.7,16.7-72.1,19.8c25.9-15.5,45.8-40.2,55.2-69.4c-24.3,14.4-51.2,24.8-79.8,30.5\n\tC492.4,15.2,459.8,0,423.7,0c-69.3,0-125.6,56.2-125.6,125.5c0,9.8,1.1,19.4,3.3,28.6C197.1,148.9,104.6,98.9,42.6,22.9\n\tC31.8,41.5,25.7,63,25.7,86c0,43.6,22.2,82,55.8,104.5c-20.6-0.7-39.9-6.3-56.9-15.8v1.6c0,60.8,43.3,111.6,100.7,123.1\n\tc-10.5,2.8-21.6,4.4-33.1,4.4c-8.1,0-15.9-0.8-23.6-2.3c16,49.9,62.3,86.2,117.3,87.2c-42.9,33.7-97.1,53.7-155.9,53.7\n\tc-10.1,0-20.1-0.6-29.9-1.7c55.6,35.7,121.5,56.5,192.4,56.5c230.9,0,357.2-191.3,357.2-357.2l-0.4-16.3\n\tC573.9,106.1,595.2,84,612,58.8z"}));
}

SocialTwitter.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 612 497.1","enableBackground":"new 0 0 612 497.1","xmlSpace":"preserve"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
